/* eslint-disable import/prefer-default-export */

// default thickness of 2px
export const thickness = 1;
export const focusedThickness = 2;
